import {
    bottomZone,
    normalizeToZone,
    topZone,
} from 'bam-node-baseball-savant/constants/zone.ts'
import type { EVPData } from '../../schema/types.ts'
import { StrikeZoneDim } from './StrikeZones/get-strike-zone-dims.ts'

export function dynamicNormalizationFeet(
    strikeZoneDims: StrikeZoneDim,
    pitch: EVPData
): { x: number; z: number } {
    if (pitch.x === null || pitch.y === null) {
        console.warn('no x/y value')
        return { x: 0, z: 0 }
    }

    if (
        pitch.szTop === null ||
        pitch.szBot === null ||
        pitch.szWidth === null
    ) {
        // no strike zone value
        return { x: pitch.x || 0, z: pitch.y || 0 }
    }

    const epsilon = 0.00001
    // Perhaps incorrectly assume we'll never have the same zone with different depths 🤔
    // Averaging brings us into fun floating point world
    const sameZone =
        Math.abs(strikeZoneDims.top - pitch.szTop) < epsilon &&
        Math.abs(strikeZoneDims.bot - pitch.szBot) < epsilon &&
        Math.abs(strikeZoneDims.width - pitch.szWidth) < epsilon

    // Save a bit of time maybe
    if (sameZone) {
        return { x: pitch.x, z: pitch.y }
    }

    return normalizeToZone(
        pitch.x,
        pitch.y,
        pitch.szTop || topZone,
        pitch.szBot || bottomZone,
        (pitch.szWidth || 17 / 12) * 12, // silly inches vs ft conversions back and forth
        strikeZoneDims.top,
        strikeZoneDims.bot,
        strikeZoneDims.width * 12 // silly inches vs ft conversions back and forth
    )
}

export function dynamicNormalization(
    strikeZoneDims: StrikeZoneDim,
    pitch: EVPData,
    xScale: d3.ScaleLinear<number, number>,
    yScale: d3.ScaleLinear<number, number>
) {
    const { x, z } = dynamicNormalizationFeet(strikeZoneDims, pitch)

    return { x: xScale(x), y: yScale(z) }
}
